import React from "react";
import { Trans } from "@lingui/macro";
import {
  DescriptionTextColumnContent,
  DescriptionTextColumnContentLeft,
  DescriptionTextColumnContentRight,
  DescriptionTextColumnTitle,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import { SpecialVoyageQuery } from "types/graphql-types";
import { DescriptionTextColumn } from "@silversea-ssc/ui-components-react";
import CruiseItineraryPortsSummary from "components/CruiseItineraryPortsSummary/CruiseItineraryPortsSummary";
import {
  ResponsiveSlideshow,
  SlideshowItem
} from "components/Slideshow/Slideshow";
import { Button } from "@silversea-ssc/ui-components-react";
import TextBox from "components/TextBox/TextBox";
import { ButtonsContainer } from "@silversea-ssc/ui-components-react";

export interface SpecialVoyageSectionItineraryContentProps {
  cruise: SpecialVoyageQuery["cruise"];
  hasExcursions: boolean;
  slideshow?: SlideshowItem[];
  uniqueCountriesCount?: number;
  uniquePortsCount?: number;
  routesCount?: number;
}

const SpecialVoyageSectionItineraryContent: React.FC<SpecialVoyageSectionItineraryContentProps> = ({
  cruise,
  hasExcursions,
  slideshow,
  uniqueCountriesCount,
  uniquePortsCount,
  routesCount
}) => {
  return (
    <SectionContainer
      spacingTop="regular"
      spacingBottom="regular"
      backgroundColor="white"
      dataContentName="section_itinerary_content"
    >
      <DescriptionTextColumn>
        <DescriptionTextColumnContent>
          <DescriptionTextColumnContentLeft>
            <DescriptionTextColumnTitle>
              {hasExcursions && <Trans>Itinerary & Excursions</Trans>}
              {!hasExcursions && <Trans>Itinerary</Trans>}
            </DescriptionTextColumnTitle>
            <CruiseItineraryPortsSummary
              ports={uniquePortsCount}
              countries={uniqueCountriesCount}
              routesCount={routesCount}
            />
            <TextBox
              fontSize="medium"
              content={cruise?.itineraryDescription?.localized}
            />

            {cruise?.customBrochureLink?.localized && (
              <ButtonsContainer spacingTop="regular" align="left">
                <Button
                  renderAs="a"
                  variant="primary"
                  href={cruise.customBrochureLink.localized}
                  target="_blank"
                  rel="noreferrer"
                  data-content-piece="view_the_brochures"
                >
                  <Trans>View the Brochure</Trans>
                </Button>
              </ButtonsContainer>
            )}
          </DescriptionTextColumnContentLeft>
          <DescriptionTextColumnContentRight>
            {slideshow && slideshow?.length > 0 && (
              <ResponsiveSlideshow items={slideshow} variant="gray" />
            )}
          </DescriptionTextColumnContentRight>
        </DescriptionTextColumnContent>
      </DescriptionTextColumn>
    </SectionContainer>
  );
};

export default React.memo(SpecialVoyageSectionItineraryContent);
